module.exports = __webpack_public_path__ + "images/800x800_Individual_0000s_0007_Suso_Juicy_ForestFruits.png";